/* ============
 * Tax Transformer
 * ============
 */

import Transformer from './transformer';

export default class TaxTransformer extends Transformer {

  static fetch(tax) {
    return {
      id: tax.id,
      taxPercentage: tax.tax_percentage,
    };
  }

  static send(tax) {
    return {
      id: tax.id,
      tax_percentage: tax.taxPercentage,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/tax.js